/* eslint-disable filenames/match-regex, local-rules/custom-naming-pattern */

export function createValidatableRegistry(key) {
  const storeProp = `__validatables_${key}`;

  const Provider = {
    created() {
      this[storeProp] = [];
    },
    provide() {
      const self = this;

      return {
        [key]: {
          register(vm) {
            if (!self[storeProp].includes(vm)) {
              self[storeProp].push(vm);
            }
          },
          unregister(vm) {
            const index = self[storeProp].indexOf(vm);
            if (index !== -1) {
              self[storeProp].splice(index, 1);
            }
          },
        },
      };
    },
    methods: {
      validateRegistered() {
        for (const child of this[storeProp]) {
          if (typeof child.validate !== 'function') {
            continue;
          }

          if (!child.validate()) {
            return false;
          }
        }

        return true;
      },
    },
  };

  const Validatable = {
    inject: {
      [key]: { default: null },
    },
    mounted() {
      const registry = this[key];
      if (registry) {
        registry.register(this);
      }
    },
    beforeUnmount() {
      const registry = this[key];
      if (registry) {
        registry.unregister(this);
      }
    },
  };

  return { Provider, Validatable };
}

const blockRegistry = createValidatableRegistry('ruleFormBlockValidator');
export const BlockValidatableProvider = blockRegistry.Provider;
export const BlockValidatable = blockRegistry.Validatable;

const conditionRegistry = createValidatableRegistry('conditionValidator');
export const ConditionValidatableProvider = conditionRegistry.Provider;
export const ConditionValidatable = conditionRegistry.Validatable;
